<template>
  <div style="display: none">
    <!-- 提示 账号不适用 MANAGE_ENTERPRISE、AUTHS、PERSONAL_AUTH、ENTERPRISE_AUTH、STAFF_AUTH  -->
    <h-msg-box
      title="提示"
      v-model="showWarning"
      class-name="warning-modal"
      :top="100"
      :width="480"
      :mask-closable="false"
      @on-close="onCloseWarning()"
    >
      <!-- 企业账号子账号数量超过20 -->
      <div class="content-box" v-if="sceneCode === 'MANAGE_ENTERPRISE'">
        <h-icon name="information-circled" size="26" color="#F2B044"></h-icon>
        <div style="flex: 1; margin-left: 10px">
          <p class="content-title">
            抱歉，当前企业账号的子账号数量已经超过了20个，不能购买该服务。
          </p>
          <p class="content-desc">
            您可以清理不需要的子账号，或者提交工单去创建一个新的企业账号。
          </p>
        </div>
      </div>
      <div class="content-box" v-if="sceneCode === 'STAFF_BUT_CUSTOMER'">
        <h-icon name="information-circled" size="26" color="#F2B044"></h-icon>
        <div style="flex: 1; margin-left: 10px">
          <p class="content-title">
            抱歉，购买该{{ packageDetail.typeLabel }}需要企业员工认证。
          </p>
          <p class="content-desc">
            该套餐的适范围为企业员工，恒生员工不能购买下单。
          </p>
        </div>
      </div>
      <!-- 当前账号不满足，但存在满足的账号 -->
      <div class="content-box" v-if="sceneCode === 'SWITCH_ACCOUNT'">
        <h-icon name="information-circled" size="26" color="#F2B044"></h-icon>
        <div style="flex: 1; margin-left: 10px">
          <p class="content-title">
            抱歉，购买该{{ packageDetail.typeLabel }}需要企业实名认证。
          </p>
          <p class="content-desc">
            您当前的登录账号还未进行企业实名认证，但识别到您已有企业实名认证的账号，是否去切换？
          </p>
        </div>
      </div>
      <!-- 需要身份认证 -->
      <div
        class="content-box"
        v-else-if="sceneCode && authSceneOptions[sceneCode]"
      >
        <h-icon name="information-circled" size="26" color="#F2B044"></h-icon>
        <div style="flex: 1; margin-left: 10px">
          <p class="content-title">
            抱歉，购买该{{ packageDetail.typeLabel }}需要{{
              authSceneOptions[sceneCode].label
            }}。
          </p>
          <p class="content-desc">
            您还未进行{{ authSceneOptions[sceneCode].label }}，请先进行<span
              class="blue"
              >{{ authSceneOptions[sceneCode].label }}</span
            >！
          </p>
        </div>
      </div>
      <p slot="footer">
        <h-button
          type="ghost"
          v-if="sceneCode !== 'STAFF_BUT_CUSTOMER'"
          @click="showWarning = false"
          >取消</h-button
        >

        <h-button
          type="primary"
          v-if="sceneCode === 'MANAGE_ENTERPRISE'"
          @click="
            showWarning = false
            goWorkOrder()
          "
          >提工单</h-button
        >
        <h-button
          type="primary"
          v-else-if="sceneCode === 'SWITCH_ACCOUNT'"
          @click="
            showWarning = false
            changeAccount()
          "
          >切换账号</h-button
        >
        <h-button
          type="primary"
          v-else-if="sceneCode === 'STAFF_BUT_CUSTOMER'"
          @click="showWarning = false"
          >我知道了</h-button
        >
        <h-button
          type="primary"
          v-else-if="sceneCode && authSceneOptions[sceneCode]"
          @click="
            showWarning = false
            goAuth()
          "
          >去认证</h-button
        >
      </p>
    </h-msg-box>
    <!-- 身份认证二次弹窗 -->
    <h-msg-box
      title="提示"
      v-model="showCheckAuth"
      class-name="warning-modal"
      :top="100"
      :width="480"
      :mask-closable="false"
    >
      <div class="content-box">
        <div style="flex: 1; margin-left: 10px">
          <p class="content-title">是否已提交身份认证？</p>
          <p class="content-desc">如果已提交请刷新当前页面</p>
        </div>
      </div>
      <p slot="footer">
        <h-button type="ghost" @click="showCheckAuth = false">取消</h-button>
        <h-button
          type="primary"
          :loading="checkAuthLoading"
          @click="updateAuthStatus()"
          >刷新</h-button
        >
      </p>
    </h-msg-box>
    <!-- 补充用户信息 -->
    <h-msg-box
      title="完善信息"
      v-model="showInformation"
      class-name="warning-modal"
      :top="100"
      :width="500"
      :mask-closable="false"
    >
      <div class="content-box">
        <h-form
          style="width: 90%"
          ref="informationFormBox"
          :model="informationForm"
          :label-width="100"
          :rules="informationRules"
        >
          <h-form-item label="公司全称" prop="subordinate_company">
            <h-select
              v-model="informationForm.subordinate_company"
              filterable
              remote
              :remote-method="companyRemoteMethod"
              :label="informationForm.companyLabel"
              allowCreate
            >
              <h-option
                v-for="option in companyOptions"
                :value="option.enterprise_name"
                :key="option.enterprise_name"
                >{{ option.enterprise_name }}</h-option
              >
            </h-select>
          </h-form-item>
          <h-form-item label="姓名" prop="company_contacts">
            <h-input
              v-model="informationForm.company_contacts"
              placeholder="请输入姓名"
              :maxlength="200"
            ></h-input>
          </h-form-item>
          <h-form-item label="手机" prop="contact_tel">
            <h-input
              v-model="informationForm.contact_tel"
              placeholder="请输入手机号"
              :maxlength="200"
            ></h-input>
          </h-form-item>
          <h-form-item label="邮箱" prop="contact_email">
            <h-input
              v-model="informationForm.contact_email"
              placeholder="请输入邮箱"
              :maxlength="200"
            ></h-input>
          </h-form-item>
        </h-form>
      </div>
      <p slot="footer">
        <h-button type="ghost" @click="showInformation = false">取消</h-button>
        <h-button
          type="primary"
          :loading="informationLoading"
          @click="confirmInformation()"
          >确定</h-button
        >
      </p>
    </h-msg-box>
  </div>
</template>

<script>
import {
  checkPurchasePermissions,
  checkUserAuthForServicePackage,
  perfectUserBaseInfoForSuscribe,
  getUserBaseInfoForSuscribe,
  fsearchForSuscribe
} from '@/api/service.js'
import validateUtils from './validator'
const { isPhoneNO, isEmail } = validateUtils
export default {
  computed: {},
  data() {
    const companyValidate = (rule, value, callback) => {
      if (value == this.informationForm.old_subordinate_company) {
        return callback()
      }
      if (value.length < 5 || value.length > 200) {
        return callback(new Error('请确认公司全称长度为5-200个字！'))
      } else {
        return callback()
      }
    }
    const contactTelValidate = (rule, value, callback) => {
      if (!isPhoneNO(value)) {
        return callback(new Error('手机格式错误'))
      } else {
        return callback()
      }
    }
    const contactEmailValidate = (rule, value, callback) => {
      if (!isEmail(value)) {
        return callback(new Error('邮箱格式错误'))
      } else {
        return callback()
      }
    }
    return {
      openLevalOptions: {
        0: '全部用户',
        1: '个人实名认证',
        2: '企业实名认证',
        3: '恒生员工认证',
        4: '企业员工认证'
      },
      packageTypeOptions: {
        0: '套餐',
        1: '加油包'
      },
      authSceneOptions: {
        AUTHS: {
          label: '身份认证',
          jump: '/cloud-console/account/identity-auth'
        },
        PERSONAL_AUTH: {
          label: '个人实名认证',
          jump: '/cloud-console/account/personal-auth'
        },
        ENTERPRISE_AUTH: {
          label: '企业实名认证',
          jump: '/cloud-console/account/enterprise-auth'
        },
        STAFF_AUTH: {
          label: '企业员工认证',
          jump: '/cloud-console/account/staff-auth'
        }
      },
      checkLoading: false,
      packageDetail: null,
      sceneCode: '',
      sceneParams: null,
      // 提示
      showWarning: false,
      showCheckAuth: false,
      checkAuthLoading: false,
      showInformation: false,
      informationLoading: false,
      informationForm: {
        old_subordinate_company: '',
        companyLabel: '',
        subordinate_company: '',
        company_contacts: '',
        contact_tel: '',
        contact_email: ''
      },
      informationRules: {
        subordinate_company: [
          { required: true, message: '公司全称不能为空', trigger: 'blur' },
          { validator: companyValidate, trigger: 'blur' }
        ],
        company_contacts: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ],
        contact_tel: [
          { required: true, message: '手机不能为空', trigger: 'blur' },
          { validator: contactTelValidate, trigger: 'blur' }
        ],
        contact_email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { validator: contactEmailValidate, trigger: 'blur' }
        ]
      },
      companyOptions: [],
      chargeInfo: {}
    }
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    // 初始化
    initCheck(chargeInfo) {
      this.chargeInfo = chargeInfo
      this.buyHandle()
    },
    // 购买套餐校验
    buyHandle() {
      if (this.checkLoading) return
      this.checkLoading = true
      checkPurchasePermissions({
        service_id: this.chargeInfo.service_id,
        service_package_id: this.chargeInfo.serial_no
      })
        .then((res) => {
          this.packageDetail = {
            ...this.chargeInfo,
            typeLabel: this.packageTypeOptions[this.chargeInfo.package_type]
          }
          this.sceneCode = res.scene_code
          // this.sceneCode = 'SWITCH_ACCOUNT'
          this.sceneParams = res.params || {}
          switch (this.sceneCode) {
            case 'SUCCESS': // 成功-跳转到订单确认页
              this.goOrderConfirm()
              break
            case 'PUT_ACCOUNT_INFO': // 补充账号信息-弹窗补充信息
              this.openInformation()
              break
            case 'STAFF_AUTH': // 所有账号都不满足适用范围，且适用范围是企业员工，引导用户跳转组件企业员工实名认证页
              this.authSceneOptions.STAFF_AUTH.label = `${this.sceneParams.open_level[0]}认证`
              this.showWarning = true
              break
            case 'SWITCH_ACCOUNT': // 当前账号不满足，返回当前用户满足套餐适用范围的其他账号id集合，弹窗提示切账号
            case 'AUTHS': // 所有账号都不满足适用范围，且适用范围多个，引导用户跳转组件身份认证首页
            case 'PERSONAL_AUTH': // 所有账号都不满足适用范围，且适用范围是个人，引导用户跳转组件个人实名认证页
            case 'ENTERPRISE_AUTH': // 所有账号都不满足适用范围，且适用范围是企业，引导用户跳转组件企业实名认证页
            case 'MANAGE_ENTERPRISE': // 企业账号子账号数量超过20-弹窗提示提工单
            case 'STAFF_BUT_CUSTOMER': // 套餐的适范围为企业员工，恒生员工不能购买下单
              this.showWarning = true
              break
          }
        })
        .finally(() => {
          this.checkLoading = false
        })
    },
    // 打开切换账号弹窗
    changeAccount() {
      this._bus.$emit(
        'callChangeAccountShow',
        this.sceneParams.account_ids || []
      )
    },
    // 打开确认订单页面
    goOrderConfirm() {
      let newUrl = `/subscription-center/packageConfirm?sid=${this.chargeInfo.service_id}&pid=${this.chargeInfo.serial_no}`
      location.href = newUrl
    },
    // 跳转认证
    goAuth() {
      const jumpUrl = this.authSceneOptions[this.sceneCode].jump
      window.open(jumpUrl)
      this.showCheckAuth = true
    },
    // 刷新认证状态
    updateAuthStatus() {
      this.checkAuthLoading = true
      checkUserAuthForServicePackage({
        service_id: this.chargeInfo.service_id,
        service_package_id: this.packageDetail.serial_no
      })
        .then((res) => {
          const statusCode = res.auth_code
          switch (statusCode) {
            case 'NOT_SUBMIT': // 没有提交认证-显示上一个弹窗
              this.showWarning = true
              break
            case 'AUTH_PENDING': // 待审核
              this.$hMessage.warning({
                content: '当前您提交的认证待审核，请审核通过后再下单！',
                duration: 5,
                closable: true
              })
              break
            case 'AUTH_SUCCESS': // 审核通过-不需要切换账号--不需要再次进行购买校验，刷新页面
              location.reload()
              // this.buyHandle(this.packageDetail)
              // EventBus.$emit('updateChangeAccountList');
              break
            case 'AUTH_SUCCESS_SWITCH': // 审核通过-需要切换账号--刷新页面，无法主动切换账号
              location.reload()
              // EventBus.$emit('callChangeAccountSubmit', {
              //   account_id: res.account_id,
              //   account_type: res.account_type
              // });
              // EventBus.$emit('updateChangeAccountList');
              break
            case 'AUTH_FAIL': // 审核不通过
              this.$hMessage.warning({
                content: '当前您提交的认证审核不通过，请重新提交认证！',
                duration: 5,
                closable: true
              })
              break
          }
        })
        .finally(() => {
          this.showCheckAuth = false
          this.checkAuthLoading = false
        })
    },
    // 显示完善信息
    openInformation() {
      this.showInformation = true
      this.informationLoading = false
      getUserBaseInfoForSuscribe().then((res) => {
        this.informationForm.subordinate_company = res.subordinate_company
        this.informationForm.old_subordinate_company = res.subordinate_company
        this.informationForm.companyLabel = res.subordinate_company
        this.informationForm.company_contacts = res.company_contacts
        this.informationForm.contact_tel = res.contact_tel
        this.informationForm.contact_email = res.contact_email
      })
    },
    // 查询公司
    companyRemoteMethod(key) {
      fsearchForSuscribe({
        enterprise_name: key
      }).then((res) => {
        this.companyOptions = res
      })
    },
    // 提交用户信息
    confirmInformation() {
      this.$refs['informationFormBox'].validate((valid) => {
        if (valid) {
          this.informationLoading = true
          perfectUserBaseInfoForSuscribe({
            ...this.informationForm
          })
            .then((res) => {
              // 提交成功--重新进行购买校验
              this.showInformation = false
              this.buyHandle(this.packageDetail)
            })
            .finally(() => {
              this.informationLoading = false
            })
        }
      })
    },
    // 跳转工单
    goWorkOrder() {
      window.open('/openplat-front/workOrder/submitWorkOrder')
    },
    // 提示弹窗关闭
    onCloseWarning() {
      this.showWarning = false
    }
  }
}
</script>
 
<style lang="scss" scoped>
/deep/ .clause-center-modal,
/deep/ .warning-modal {
  .h-modal-body {
    padding: 16px 32px;
  }
}
.warning-modal {
  .content-box {
    display: flex;
    align-items: flex-start;
    .h-icon {
      line-height: 26px;
    }
    .content-title {
      font-size: 16px;
      color: #000;
    }
    .content-desc {
      font-size: 14px;
      padding-top: 10px;
      .blue {
        color: #004cff;
      }
    }
  }
}
.clause_box {
  height: 100%;
  border: 1px solid #ddd;
  padding: 4px 10px;
  overflow: auto;
}
.clause_footer {
  margin: 0 auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/components/buyCheck.vue